import React from 'react';
import Map from '../components/Map';
import useBreakpoints from '../hooks/useBreakPoint';

const centerCoordinates = { lat: 36.123, lng: -95.95888 };
const enterpriseLocations = [
  {
    name: 'Headquarters',
    address: '910 South Hudson Ave',
    city: 'Tulsa',
    state: 'OK',
    zipCode: 74112,
    coordinates: { lat: 36.149429, lng: -95.913879 },
    phone: '918-585-2347',
  },
  {
    name: 'St. Francis\nHealth System',
    address: '6161 S Yale Ave',
    city: 'Tulsa',
    state: 'OK',
    zipCode: 74112,
    coordinates: { lat: 36.07276, lng: -95.91959 },
    phone: '918-585-2347',
  },
];

const Locations = () => {
  const { isLg } = useBreakpoints();
  const mapRef = React.useRef();
  const buttonRef = React.useRef();

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <>
      <h2 className="bg-gradient-to-b from-enterpriseOrange-500 via-enterpriseOrange-600 to-enterpriseOrange-800 text-white font-montserrat font-bold text-2xl leading-8 pb-4 pt-12 pl-8 md:text-4xl md:leading-10 md:pt-9 md:pl-20 lg:text-5xl lg:leading-14 lg:pb-5 lg:pt-16 lg:pl-24 2xl:text-6xl 2xl:leading-20 2xl:pb-6 2xl:pt-24 2xl:pl-36 3xl:text-7.6xl 3xl:leading-24 3xl:pb-8 3xl:pt-28 3xl:pl-48 uppercase">
        Locations
      </h2>
      <div className="mx-8 my-6 md:flex md:flex-row md:mx-20 md:mt-16 md:mb-36 lg:mx-24 lg:mb-48 2xl:block 2xl:mx-36 2xl:mt-18 3xl:mx-48 3xl:mt-24">
        <div className="relative h-64 mb-6 md:flex-grow md:h-92 md:mr-6 lg:h-116">
          <Map
            zoomOutLevel={isLg ? 12 : 11}
            ref={mapRef}
            center={centerCoordinates}
            zoom={isLg ? 12 : 11}
            scrollWheelZoom={false}
            markers={enterpriseLocations.map(({ coordinates, address }) => ({
              coordinates,
              address,
            }))}
            className="rounded-2xl"
          />
          <button
            ref={buttonRef}
            type="button"
            className="z-30 hidden uppercase font-bold text-white bg-enterpriseOrange-500 hover:bg-enterpriseOrange-800 px-3 py-1 border-4 border-white rounded-lg absolute top-3 right-3 2xl:py-3 2xl:rounded-2xl"
            onClick={() => {
              mapRef.current.zoomOutTo(centerCoordinates);
              buttonRef.current.style.display = 'none';
            }}
          >
            Reset
          </button>
        </div>
        <div className="flex flex-row flex-wrap md:flex-col 2xl:grid 2xl:grid-cols-2">
          {enterpriseLocations.map(
            ({ name, phone, address, city, state, zipCode, coordinates }) => (
              <div
                className="flex flex-row-reverse mr-5 md:flex-col 2xl:flex-row-reverse"
                key={name}
              >
                <div className="flex-grow">
                  <h3 className="mb-2 font-montserrat font-bold text-xl leading-1.2em lg:text-2xl lg:leading-1.2em 2xl:text-3.5xl 2xl:leading-1.2em">
                    {name.split('\n').map((line, index) => (
                      <span
                        className="block 3xl:inline-block 3xl:mr-2.5"
                        key={index}
                      >
                        {line}
                      </span>
                    ))}
                  </h3>
                  <address className="not-italic mb-2 font-montserrat leading-1.55em text-techsicoGray-400 text-sm lg:text-base lg:mb-3 2xl:text-2xl 2xl:leading-1.55em">
                    {address}
                    <br />
                    {city},{state} {zipCode}
                  </address>
                  <a
                    href={`tel:+1-${phone}`}
                    className="block font-montserrat leading-1.55em text-techsicoGray-400 hover:underline text-sm mb-4 md:mb-1.5 lg:text-base lg:mb-3 2xl:text-2xl"
                  >
                    {phone}
                  </a>
                </div>
                <div>
                  <button
                    type="button"
                    className="uppercase font-bold text-white bg-enterpriseOrange-500 hover:bg-enterpriseOrange-800 px-3 py-1 border-4 border-white rounded-lg mr-4.5 md:mb-8 md:text-xl 2xl:ml-18 2xl:mr-8 2xl:py-3 2xl:rounded-2xl 3xl:ml-36"
                    onClick={() => {
                      mapRef.current.zoomInTo(coordinates);
                      buttonRef.current.style.display = 'block';
                    }}
                  >
                    View
                  </button>
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </>
  );
};

export default Locations;
